import LeveyJenningsChart from './LeveyJenningsChart'

export default LeveyJenningsChart
